import { Facebook } from "./Facebook"
import { Instagram } from "./Instagram"
import { LinkedIn } from "./LinkedIn"
import { Twitter } from "./Twitter"
import { Youtube } from "./Youtube"
import { Charleshurst } from "./Charleshurst"
import { Lookers } from "./Lookers"
import { CopyrightAndCompliance } from "./CopyrightAndCompliance"

interface FooterProps {
  groupId: number
}

interface LogosToRenderProps {
  ariaLabel: string;
  href: string;
  logo: any;
  group: number;
}

const BASE_URL = `${window.location.origin}`;

const Footer: React.FC<FooterProps> = ({ groupId }) => {
  const LogosToRender = () => {
    const groups: LogosToRenderProps[] = [
      {
        ariaLabel: 'Lookers',
        href: 'https://www.lookers.co.uk/',
        logo: <Lookers />,
        group: 1
      },
      {
        ariaLabel: 'Charles Hurst',
        href: 'https://www.charleshurstgroup.co.uk/',
        logo: <Charleshurst />,
        group: 2
      },
    ]

    const filteredGroups = groups.filter((group) => {
      return group.group !== groupId
    }) 
   
    return (
      <div className="footer-sublinks">
        {filteredGroups.map((currentgroups) => {
          const { ariaLabel, href, logo, group } = currentgroups
          return (              
            <a
            key={group}
            aria-label={ariaLabel}
            href={href}
            >
            {logo}
            </a>              
          )
        })}
      </div>
    )
  }
  
  return (
    //FOOTER CONTAINER
    <div className="footer-container">
      <div className="footer-heading">
        <h3>A good deal. Better.</h3>
        <div className="seperator-footer"></div>
      </div>

      <div className="footer-content">
        <div className="footer-services">
          {/* <h3>Selling a car</h3> */}
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/terms-and-conditions`}
            >
              Terms & Conditions
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
               href={`${BASE_URL}/cookie-policy`}
            >
              Cookie Policy
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/privacy-notice`}
            >
              Privacy Notice
            </a>
          </p>
          <p>
            <a href="https://www.lookers.co.uk/-/media/Lookers-Group/Group/PDFs/ClickSellterms-221021.pdf?la=en&rev=a017beacfb3d4838839ef2377f8a7daf&hash=44FD5F3B71A1051C0E69F02E2A4BD64D4EEDE8C1">
              Click and Sell Terms
            </a>
          </p>
          <p>
            <a href="https://www.lookers.co.uk/-/media/lookers-group/group/pdfs/lookers-customer-toba-v3-12_23-final.pdf?rev=3eca9e91b720462184f4d8c63864e5de">
              Terms of Business
            </a>
          </p>

          <p>
            <a href={`${BASE_URL}/modern-slavery-statement`}>
              Modern Slavery Statement
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.motability.co.uk/"
            >
              Motability Partner
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.specialistautomotivefinance.org.uk/home/"
            >
              Specialist Automotive Finance
            </a>
          </p>
        </div>
        <div className="footer-help">
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/about-us`}             
            >
              About Us
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/terms-and-conditions/click-and-sell-faqs`}
            >
              FAQs
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={groupId === 1 ? `${BASE_URL}/careers` : "https://careersni-lookersplc.icims.com/jobs"}
            >
              Careers
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/call-policy`}
            >
              Call Policy
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/complaints`}             
            >
              Complaints
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${BASE_URL}/contact-us`}             
            >
              Contact Us
            </a>
          </p>
          <p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.themotorombudsman.org/"
            >
              Motor ombudsman
            </a>
          </p>
        </div>
        <div className="footer-link-social">
          <p className="social-links">Connect with us</p>
          <div className="footer-social">
            <a
              aria-label="Lookers Facebook"
              href="https://www.facebook.com/lookersgroup"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook />
            </a>

            <p>
              <a
                aria-label="Lookers Twitter"
                href="https://twitter.com/lookersgroup"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </a>
            </p>
            <p>
              <a
                aria-label="Lookers YouTube"
                href="https://www.youtube.com/user/LookersWebTV"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube />
              </a>
            </p>
            <p>
              <a
                aria-label="Lookers Instagram"
                href="https://www.instagram.com/lookersgroup/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </a>
            </p>
            <p>
              <a
                aria-label="Lookers LinkedIn"
                href="https://www.linkedin.com/company/lookers-plc/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedIn />
              </a>
            </p>
          </div>
          <LogosToRender />
        </div>
      </div>
      <div className="footer-outer-container">
        <CopyrightAndCompliance groupId={groupId} />
      </div>
    </div>
  )
}

export default Footer
